import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.1.1?node-id=9405%3A25332
 *
 * @param {object} props - svg props
 */
export const BarsIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path opacity='0.5' d='M18.8499 7H18.1499C17.5976 7 17.1499 7.44772 17.1499 8V16C17.1499 16.5523 17.5976 17 18.1499 17H18.8499C19.4022 17 19.8499 16.5523 19.8499 16V8C19.8499 7.44772 19.4022 7 18.8499 7Z' fill={color}/>
            <path d='M5.8499 13H5.1499C4.59762 13 4.1499 13.4477 4.1499 14V16C4.1499 16.5523 4.59762 17 5.1499 17H5.8499C6.40219 17 6.8499 16.5523 6.8499 16V14C6.8499 13.4477 6.40219 13 5.8499 13Z' fill={color}/>
            <path opacity='0.5' d='M14.45 9H13.75C13.1977 9 12.75 9.44772 12.75 10V16C12.75 16.5523 13.1977 17 13.75 17H14.45C15.0023 17 15.45 16.5523 15.45 16V10C15.45 9.44772 15.0023 9 14.45 9Z' fill={color}/>
            <path d='M8.44971 12C8.44971 11.4477 8.89742 11 9.44971 11H10.1497C10.702 11 11.1497 11.4477 11.1497 12V16C11.1497 16.5523 10.702 17 10.1497 17H9.44971C8.89742 17 8.44971 16.5523 8.44971 16V12Z' fill={color}/>
        </SvgIcon>
    )
}

export default BarsIcon
